import React, { useState } from "react";
import ProgramCard from "./ProgramCard";
import MapView from "./MapView";

const ListeCarte = ({
  listeDesProgrammes,
  programmeListMap,
  programmesCoordinates,
  filterInput,
  ongletType,
  ongletId,
  query,
  ongletName,
}) => {
  const [selectedProgram, setSelectedProgram] = useState(null);

  return (
    <div className="d-flex flex-column">
      <div className="d-flex p-0 gap10 mt-10 position-relative">
        <div className="w40">
          <ProgramCard
            listeDesProgrammes={programmeListMap}
            selectedProgram={selectedProgram}
            setSelectedProgram={setSelectedProgram}
          />
        </div>
        <div className="w70 position-sticky top-0" style={{ height: "100vh" }}>
          <MapView
            locations={programmesCoordinates}
            zoom={4.6}
            searchOnMap={true}
            filterInput={filterInput}
            ongletType={ongletType}
            ongletId={ongletId}
            query={query}
            ongletName={ongletName}
            setSelectedProgram={setSelectedProgram}
            selectedProgram={selectedProgram}
          />
        </div>
      </div>
    </div>
  );
};

export default ListeCarte;
